// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"8f6185e0","271":"0d2b0911","511":"665e38b7","588":"36bee716","746":"ccddcd34","886":"12d8acef","929":"b8780278","968":"2dd8dd01"}[chunkId] + ".chunk.js";
};